(() => {
  if (window.__affirmMessagingInit) return;
  window.__affirmMessagingInit = true;

  const refresh = () => {
    if (window.affirm && window.affirm.ui && window.affirm.ui.refresh) {
      window.affirm.ui.refresh();
    }
  };

  const onVariantChange = (event) => {
    const price = event.detail?.variant?.price;
    if (price == null) return;

    document.querySelectorAll('[data-affirm-messaging]').forEach((element) => {
      element.setAttribute('data-amount', price);
    });

    refresh();
  };

  document.addEventListener('variant:change', onVariantChange);
  document.addEventListener('shopify:section:load', refresh);
})();
